/**
 * Ticks every [data-product-leaving-countdown] toward data-end (unix seconds, UTC).
 */
(function () {
  "use strict";

  function pad(value) {
    var n = Math.max(0, value);
    return n < 10 ? "0" + n : String(n);
  }

  function paint(root, hours, minutes, seconds) {
    var map = {
      hours: pad(hours),
      minutes: pad(minutes),
      seconds: pad(seconds),
    };
    root.querySelectorAll("[data-plc]").forEach(function (el) {
      var key = el.getAttribute("data-plc");
      if (map[key] == null) return;
      var cells = el.querySelectorAll("[data-plc-cell]");
      if (!cells.length) {
        el.textContent = map[key];
        return;
      }
      var chars = map[key].split("");
      if (chars.length < cells.length) {
        while (chars.length < cells.length) chars.unshift("0");
      }
      var start = chars.length - cells.length;
      cells.forEach(function (cell, index) {
        cell.textContent = chars[start + index] || "0";
      });
    });
  }

  function tick(root) {
    var end = Number(root.getAttribute("data-end")) * 1000;
    var diff = end - Date.now();
    if (!Number.isFinite(end) || diff <= 0) {
      root.hidden = true;
      return;
    }
    var hours = Math.floor(diff / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);
    paint(root, hours, minutes, seconds);
  }

  function boot() {
    var nodes = document.querySelectorAll("[data-product-leaving-countdown]");
    if (!nodes.length) return;
    function update() {
      nodes.forEach(tick);
    }
    update();
    window.setInterval(update, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
